export const mutations = {
  SET_PURCHASE_METHODS(state, data) {
    state.purchaseMethods = data;
  },
  SET_BLUESNAP_TOKEN(state, token) {
    state.bluesnapToken = token;
  },
  SET_BLUESNAP_LOADING(state, status) {
    state.bluesnapLoading = status;
  },
  SET_BLUESNAP_ERROR(state, error) {
    state.bluesnapError = error;
  },
  SET_BLUESNAP_ERROR_SHOW_PAYPAL(state, status) {
    state.bluesnapErrorShowPaypalButton = status;
  },
  SET_STRIPE_ERROR(state, status) {
    state.stripeError = status;
  },
  SET_PAYPAL_ERROR(state, status) {
    state.paypalError = status;
  }
};

export const getters = {
  getPurchaseMethods(state) {
    return state.purchaseMethods;
  }
};

export const actions = {
  async GET_PURCHASE_METHODS({ commit }) {
    try {
      commit('SET_PURCHASE_METHODS', { options: [], default: '' });
      const response = await this.$axios.get('purchases/methods/');
      if (!response.data.error && !response.error) {
        const { data } = response.data;
        commit('SET_PURCHASE_METHODS', data);
      }
    } catch (error) {
      const data = {
        options: ['paypal', 'bluesnap'],
        default: 'paypal'
      };
      commit('SET_PURCHASE_METHODS', data);
      console.error('Payments | GET_PURCHASE_METHODS:', error);
    }
  },
  async GET_BLUESNAP_TOKEN({ commit }, data) {
    var hasError = false;
    try {
      const response = await this.$axios.post('purchases/bluesnap/validate/', data);
      const token = response.data.data.token ? response.data.data.token : false;
      if (token) {
        commit('SET_BLUESNAP_TOKEN', token);
        commit('SET_BLUESNAP_ERROR_SHOW_PAYPAL', false);
        commit('SET_BLUESNAP_ERROR', false);
      } else {
        hasError = true;
      }
    } catch (error) {
      hasError = true;
    }
    if (hasError) {
      commit('SET_BLUESNAP_ERROR', 'purchase.bluesnap.errors.cannotCommunicate');
      commit('SET_BLUESNAP_ERROR_SHOW_PAYPAL', true);
    }
  },
  async PROCESS_BLUESNAP_PAYMENT({ commit }, data) {
    var result = false;
    commit('SET_BLUESNAP_LOADING', true);
    try {
      const response = await this.$axios.post('purchases/bluesnap/payment/', data, {
        withCredentials: true
      });
      if (response.data.error) {
        commit('SET_BLUESNAP_ERROR', 'purchase.bluesnap.errors.paymentError');
        commit('SET_BLUESNAP_ERROR_SHOW_PAYPAL', true);
      } else {
        this.$auth.fetchUser(true);
        commit('SET_BLUESNAP_ERROR', false);
        commit('SET_BLUESNAP_ERROR_SHOW_PAYPAL', false);
        result = true;
      }
    } catch (error) {
      console.error('Payments | PROCESS_BLUESNAP_PAYMENT:', error);
    }
    commit('SET_BLUESNAP_LOADING', false);
    return result;
  },
  async PROCESS_STRIPE_PAYMENT({ commit }, data) {
    try {
      const response = await this.$axios.post('/stripe/purchase/', data, {
        withCredentials: true
      });
      if (!response.data.error && !response.error) {
        this.$auth.fetchUser(true);
        commit('SET_STRIPE_ERROR', false);
      } else {
        commit('SET_STRIPE_ERROR', true);
      }
    } catch (error) {
      console.error('Payments | PROCESS_STRIPE_PAYMENT:', error);
      commit('SET_STRIPE_ERROR', true);
    }
  },
  async PROCESS_PAYPAL_PAYMENT({ commit }, data) {
    try {
      const response = await this.$axios.post('purchases/payment/', data, {
        withCredentials: true
      });
      if (!response.data.error && !response.error) {
        this.$auth.fetchUser(true);
        commit('SET_PAYPAL_ERROR', false);
      } else {
        commit('SET_PAYPAL_ERROR', true);
      }
    } catch (error) {
      console.error('Payments | PROCESS_PAYPAL_PAYMENT:', error);
      commit('SET_PAYPAL_ERROR', true);
    }
  }
};

export const state = () => ({
  purchaseMethods: {},
  bluesnapToken: false,
  bluesnapLoading: false,
  bluesnapError: false,
  bluesnapErrorShowPaypalButton: false,
  stripeError: false,
  paypalError: false
});
